import { Badge, COLOR, PLACEMENT } from 'baseui/badge';
import { KIND as ButtonKind } from 'baseui/button';
import { SIZE as DividerSize, StyledDivider } from 'baseui/divider';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import AccountingDetail from './AccountingDetail';
import PriceChangeTable from './PriceChangeTable';
const ProjectAccountingModal = ({
  projectId,
  hideModal,
  isVisible
}) => {
  const handleClose = () => {
    hideModal();
  };
  return <Modal onClose={handleClose} isOpen={isVisible} closeable animate size={SIZE.auto} role={ROLE.dialog}>
      <ModalHeader>Project {projectId} Accounting</ModalHeader>
      <StyledDivider $size={DividerSize.section} />

      <Badge placement={PLACEMENT.rightTopEdge} content="GTI Internal ONLY" color={COLOR.negative} overrides={{
      Root: {
        style: ({
          $theme
        }) => ({
          width: '100%'
        })
      }
    }}>
        <ModalBody>
          <AccountingDetail projectId={projectId} />

          <StyledDivider $size={DividerSize.section} />
          <PriceChangeTable projectId={projectId} />
        </ModalBody>
      </Badge>
      <ModalFooter>
        <ModalButton data-testid="accounting-close-button" kind={ButtonKind.tertiary} onClick={() => handleClose()}>
          Close
        </ModalButton>
      </ModalFooter>
    </Modal>;
};
export default ProjectAccountingModal;